<template>
  <screen
    v-show="show"
    :screen-name="$t('tutorial.title')"
    :screen-info="$t('tutorial.return')"
    @skip="$emit('skip')"
  >
    <circle-window>
      <hand-raise raiseSide="left" />
    </circle-window>
  </screen>
</template>

<script>
import autoNext from '../../mixins/auto-next';

import Screen from '../common/Screen.vue';
import CircleWindow from './CircleWindow.vue';
import HandRaise from './HandRaise.vue';

export default {
  name: 'HandRaiseLeft',
  components: {
    Screen,
    CircleWindow,
    HandRaise,
  },
  mixins: [autoNext],
  data: () => ({
    duration: 2.5,
  }),
};
</script>
